import { combineReducers, createReducer, PayloadAction } from "@reduxjs/toolkit";
import {
  projectsCloneDialog,
  projectsCloneError,
  projectsCloneNext,
  projectsCloneStart,
  projectsCloneSuccess
} from "../Actions";

const showDialog = createReducer(false, {
  [projectsCloneDialog.type]: (_, { payload }: PayloadAction<boolean>) => payload,
  [projectsCloneError.type]: () => false,
  [projectsCloneSuccess.type]: () => false
});

const cloneIndex = createReducer(-1, {
  [projectsCloneStart.type]: () => 0,
  [projectsCloneNext.type]: (state) => state + 1,
  [projectsCloneSuccess.type]: () => -1,
  [projectsCloneError.type]: () => -1
});

export const Clone = combineReducers({
  showDialog,
  cloneIndex
});
